/**
 * Created by stas on 5/25/2017.
 */
export enum Component {
    AgentManagement = 1,
    LocationManagement = 2,
    ExchangeRates = 3,
    CustomerManagement = 4,
    Calculator = 5,
    ProductManagement = 6,
    OrderManagement = 7,
    Reports = 8,
    OrderDetails = 9,
    Dashboard = 10,
    Amazon = 11,
    AmazonManagement = 12,
    TariffUpdater = 13,
    StatusAPI = 14,
    CustomersImport = 15
}


// WEBPACK FOOTER //
// ./app/objects/components/component.ts